import React from "react";
import EastIcon from "@mui/icons-material/East";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AbsoluteSkewebar from "../Common/AbsoluteSkewebar";
const hiringDatas = [
  {
    id: 1,
    image:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112076.svg",
    name: "Customer First",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
  {
    id: 3,
    image:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112138.svg",
    name: "Be Curious",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
  {
    id: 2,
    image:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112216.svg",
    name: "Be Persistent Yet Flexible",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
  {
    id: 5,
    image:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112267.svg",
    name: "Just Do It",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
  {
    id: 4,
    image:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112302.svg",
    name: "We Win Together, We Learn Together",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },

  {
    id: 6,
    image:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112343.svg",
    name: "Think Like an Entrepreneur",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
];

const CareerCard = () => {
  return (
    <div className=" my-10 md:my-14">
      <div className="w-full relative flex md:pt-12  mb-4  md:mb-10">
        <AbsoluteSkewebar text={"Why be an Elchemist"} />
      </div>
      <div className=" w-[full] flex flex-col gap-8 font-normal text-[#666666]">
        <p>
          At Elchemy, we're not just a company; we're a catalyst for your
          professional growth and personal success. Here's why you should embark
          on your career journey with us:
        </p>
        <p>
          Our Core Values are our North Star, they bring us all together on a
          common path to drive success for the organization and for our personal
          career. Our values illuminate the path forward and steer us toward
          excellence in everything we do. They are the principles that define
          us, inspire us, and unite us:
        </p>
      </div>

      <div className="flex flex-wrap  sm:gap-28  md:gap-0 md:flex md-w-full md:flex-row  items-start sm:justify-around sm:mb-24 md:mt-6">
        {hiringDatas?.map((hiringData, index) => (
          <>
            <div
              className="flex flex-col  items-center  sm:mb-5   md:ml-[1.2rem] mt-10 md:mb-0 md:mr-5 w-[50%] sm:w-[12%]"
              key={hiringData?.id}
            >
              <div className=" w-full  h-[3rem] object-cover  md:w-[50px] md:h-[50px] font-mukta  flex justify-center  items-center">
                <img src={hiringData?.image} alt={hiringData?.name} />
              </div>
              <h5 className="text-[#161616] font-medium text-[15px] w-[80%] md:w-[80%] md:text-[15px] font-Mukta capitalize mt-3 text-center break-normal">
                {hiringData?.name}
              </h5>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default CareerCard;
